import { Button } from '@/components/ui/button';
import { Facebook, Twitter, Linkedin, Share2 } from 'lucide-react';

interface SocialShareProps {
  url: string;
  title: string;
}

const SocialShare = ({ url, title }: SocialShareProps) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`
  };

  const handleShare = (platform: 'facebook' | 'twitter' | 'linkedin') => {
    const width = 600;
    const height = 400;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;

    window.open(
      shareLinks[platform],
      'share',
      `width=${width},height=${height},left=${left},top=${top}`
    );
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="icon"
        className="rounded-full hover:bg-blue-100 hover:text-blue-600"
        onClick={() => handleShare('facebook')}
      >
        <Facebook className="w-5 h-5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="rounded-full hover:bg-sky-100 hover:text-sky-600"
        onClick={() => handleShare('twitter')}
      >
        <Twitter className="w-5 h-5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="rounded-full hover:bg-blue-100 hover:text-blue-600"
        onClick={() => handleShare('linkedin')}
      >
        <Linkedin className="w-5 h-5" />
      </Button>
    </div>
  );
};

export default SocialShare; 